import { render, staticRenderFns } from "./ClientCreateModal.vue?vue&type=template&id=ceda24f6&scoped=true&"
import script from "./ClientCreateModal.vue?vue&type=script&lang=js&"
export * from "./ClientCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceda24f6",
  null
  
)

export default component.exports